import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import {
  IGetCurrentAccountResponse,
  VerificationCodeStatus,
} from 'api/curo/VerificationProcessApi';
import {
  getCurrentAccount,
  logout,
  verifyEmailVerificationCode,
  verifyPhoneVerificationCode,
} from 'thunks';

import { resetCuroStore } from './actions';

export type AccountDataType = IGetCurrentAccountResponse;

export interface ISignInProcessState {
  phone: string;
  email: string;
  accountData: AccountDataType | null;
}

const initialState: ISignInProcessState = {
  phone: '',
  email: '',
  accountData: null,
};

const signInProcessSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setPhone: (state, action: PayloadAction<{ phone: string }>) => {
      state.phone = action.payload.phone;
    },
    setEmail: (state, action: PayloadAction<{ email: string }>) => {
      state.email = action.payload.email;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCurrentAccount.fulfilled, (state, { payload }) => {
        const { email, phone } = payload;
        state.phone = phone;
        state.email = email;
        state.accountData = payload;
      })
      .addCase(verifyEmailVerificationCode.fulfilled, (state, { payload }) => {
        if (payload.status === VerificationCodeStatus.Approved) {
          state.accountData!.isEmailVerified = true;
        }
      })
      .addCase(verifyPhoneVerificationCode.fulfilled, (state, { payload }) => {
        if (payload.status === VerificationCodeStatus.Approved) {
          state.accountData!.isPhoneVerified = true;
        }
      });
    [logout.rejected, logout.fulfilled, resetCuroStore].map((thunk) =>
      builder.addCase(thunk, () => initialState),
    );
  },
});

export const { setPhone, setEmail } = signInProcessSlice.actions;
export default signInProcessSlice.reducer;
